<template>
  <v-row class="charts-container">
    <v-col>
      <DonutChart
        :series="series"
        :plays="[
          summarizedDevicesInfo.desktop.play,
          summarizedDevicesInfo.mobile.play,
          summarizedDevicesInfo.others.play,
        ]"
      />
    </v-col>
    <v-col>
      <CardItem :item="summarizedDevicesInfo.desktop">
        <template #icon>
          <img
            src="@/assets/pandaIcons/desktop_dark.svg"
            class="mb-4 head-card-img"
            v-if="$vuetify.theme.dark"
          />
          <img
            src="@/assets/pandaIcons/desktop.svg"
            v-else
            class="mb-4 head-card-img"
          />
        </template>
      </CardItem>
    </v-col>
    <v-col>
      <CardItem :item="summarizedDevicesInfo.mobile">
        <template #icon>
          <img
            src="@/assets/pandaIcons/phone_dark.svg"
            class="mb-4 head-card-img"
            v-if="$vuetify.theme.dark"
          />
          <img
            src="@/assets/pandaIcons/phone.svg"
            v-else
            class="mb-4 head-card-img"
          /> </template
      ></CardItem>
    </v-col>
    <v-col>
      <CardItem :item="summarizedDevicesInfo.others">
        <template #icon>
          <img
            src="@/assets/pandaIcons/table_dark.svg"
            class="mb-4 head-card-img"
            v-if="$vuetify.theme.dark"
          />
          <img
            src="@/assets/pandaIcons/table.svg"
            v-else
            class="mb-4 head-card-img"
          />
        </template>
      </CardItem>
    </v-col>
  </v-row>
</template>

<script>
import DonutChart from '@/views/AnalyticsV3/components/Charts/Donut.vue'
import CardItem from '@/views/AnalyticsV3/components/Charts/CardItem.vue'

export default {
  name: 'HeadCards',
  components: {
    DonutChart,
    CardItem,
  },
  props: {
    series: {
      type: Array,
      required: true,
    },
    summarizedDevicesInfo: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.head-card-img {
  width: 24px;
  height: 24px;
}
</style>
